export default __webpack_public_path__ + "static/media/cemerem_2_6400x4236.c0ec6e4d.png";